<template>
  <div class="h-full">
    <router-view />
    <Notification
      v-if="loadNotification"
      :text="notificationText"
      :show="showNotification"
    />
  </div>
</template>
<script>
import { Redirect } from "@shopify/app-bridge/actions";
import Notification from "./components/Common/Notification.vue";
export default {
  components: {
    Notification
  },
  data() {
    return {
      notificationText: "",
      showNotification: false,
      loadNotification: false
    };
  },
  created() {
    this.$store.dispatch("initAppBridge").then(app => {
      this.subscribeToNavRedirect(app);
    });
    window.addEventListener("ToastNotify", event => {
      this.displayNotification(event.detail.text);
    });
  },
  mounted() {
    setTimeout(() => {
      this.loadNotification = true;
    }, 3000);
  },
  methods: {
    subscribeToNavRedirect(app) {
      if (app) {
        console.log("app location", location);

        if (location.pathname) {
          if (location.pathname.indexOf("/api/shopify/connect") > -1) {
            this.$router.push({ path: "/overview" });
          } else if (location.pathname === "/") {
            this.$router.push({ path: "/overview" });
          } else {
            this.$router.push({ path: location.pathname });
          }
        }

        app.subscribe(Redirect.Action.APP, redirectData => {
          console.log(redirectData.path); // For example, '/settings'
          if (redirectData.path.indexOf("/api/shopify/connect") > -1) {
            this.$router.push({ path: "/overview" });
          } else {
            this.$router.push({ path: redirectData.path });
          }
        });
      }
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    }
  }
};
</script>

<style lang="scss"></style>
